import { RootState } from "../../../app/store/rootReducer";

export const logInState = (state: RootState) => state.auth.loginState;
export const authError = (state: RootState) => state.auth.error;
